import { jsx as _jsx } from "react/jsx-runtime";
// routes/SigninOidcCallback.tsx
import { useEffect } from 'react';
import { userManager } from '../../apis/auth.api';
import { setProfileToLS } from '../../utils/auth';
import { Spin } from 'antd';
export function SigninOidcCallback() {
    useEffect(() => {
        (async () => {
            try {
                const user = await userManager.signinRedirectCallback();
                // user.access_token, user.expires_at, user.state (chứa pathname nếu bạn truyền lúc redirect)
                setProfileToLS(user);
                // ưu tiên state từ signinRedirect(state: { pathname })
                const fromState = user?.state?.pathname;
                const fromLS = localStorage.getItem('returnUrl');
                const next = fromState || fromLS || '/';
                // dọn cờ và chuyển trang
                localStorage.removeItem('returnUrl');
                window.location.replace(next);
            }
            catch (err) {
                console.error('signinRedirectCallback failed', err);
                // fallback an toàn để không kẹt vòng lặp
                window.location.replace('/');
            }
        })();
    }, []);
    return (_jsx("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }, children: _jsx(Spin, { tip: 'Logging in', size: 'large' }) }));
}
